export default "__VITE_ASSET__tacUYth4__"